import { render, staticRenderFns } from "./radar3.vue?vue&type=template&id=0fec999a&"
import script from "./radar3.vue?vue&type=script&lang=js&"
export * from "./radar3.vue?vue&type=script&lang=js&"
import style0 from "./radar3.vue?vue&type=style&index=0&id=0fec999a&prod&lang=less&scopded=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports